import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Local from "model/patrimonio/Local";
import MovimentoPatrimonio from "model/patrimonio/MovimentoPatrimonio";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class MovimentoPatrimonioService {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/movimentoPatrimonio/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    
    consultar(id: number) {
        return new Promise<MovimentoPatrimonio>((resolve, reject): void => {});
    }

    incluir(movimentoPatrimonio: MovimentoPatrimonio) {
        return new Promise<MovimentoPatrimonio>((resolve, reject): void => {});
    }

    editar(movimentoPatrimonio: MovimentoPatrimonio) {
        return new Promise<MovimentoPatrimonio>((resolve, reject): void => {});
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {});
    }

    locais() {
        return new Promise<Local[]>((resolve, reject): void => {
            api
                .get(`/movimentoPatrimonio/locais`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pessoas() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/movimentoPatrimonio/pessoas`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/movimentoPatrimonio/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTipo(tipo: string): string {
        if(tipo==="TRANSFERENCIA") return "Transferência";
        if(tipo==="EMPRESTIMO") return "Empréstimo";
        if(tipo==="DEVOLUCAO") return "Devolução";
        return "";
    }

    getListaTipoFilter() {
        return [
            { label: "Transferência", value: "T" },
            { label: "Empréstimo", value: "E" },
            { label: "Devolução", value: "D" }
        ]
    }
}

export default MovimentoPatrimonioService;